import React from "react";
import ModalView from "@modals/modalview/ModalView";
import alertIcon from "@assets/icons/validation-fail.svg";
import { unassignEvaluationTask } from "@services/evaluationService";
import styles from "./ReturnToDashboard.module.css";

interface ReturnToDashboardProps {
  isOpen: boolean;
  onClose: () => void;
}
function ReturnToDashboard({ isOpen, onClose }: ReturnToDashboardProps) {
  const accesstoken = localStorage.getItem("accessToken");
  const handleCancel = () => {
    onClose();
  };
  const handleUnassign = async () => {
    const res = await unassignEvaluationTask();
    if (res) {
      onClose();
      window.location.href = "/evaluator-dashboard";
    }
  };

  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        <img src={alertIcon} className={styles.alertImage} />
        <div className={styles.headingtext}>Return to Dashboard?</div>
        <p>
          This will un-assign you from the current evaluation task. Your
          progress will not be saved.
        </p>
        <div className={styles.btnContainer}>
          <button className={styles.cancelBtn} onClick={handleCancel}>
            CANCEL
          </button>
          <button className={styles.unassignBtn} onClick={handleUnassign}>
            UNASSIGN
          </button>
        </div>
      </div>
    </ModalView>
  );
}

export default ReturnToDashboard;
